const validationHeader = 'form.validation'

const composeValidators = (...validators: ((value: string) => string | undefined)[]) => (
    value: string) =>
        validators.reduce((error, validator) => error || validator(value), undefined as string | undefined)

const required = (name: string) => (value: any) => (value ? undefined : `${validationHeader}.required.${name}`)
const email = (name: string) => (value: string) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? undefined : `${validationHeader}.email.${name}`
const password = (name: string) => (value: string) => /(?=^[\S]+.*[\S]+$)(?=.*[a-z])(?=.*[0-9])/.test(value) ?
    undefined : `${validationHeader}.password.${name}`
const minLength = (name: string, minLength: number) => (value: string) =>
    value.length >= minLength ? undefined : `${validationHeader}.min-length-${minLength}.${name}`
const noNumbers = (name: string) => (value: string) => /\d/.test(value) ?
    `${validationHeader}.no-numbers.${name}` : undefined
const postcode = (name: string) => (value: string) => /^\d{4}$/.test(value) ?
    undefined : `${validationHeader}.postcode.${name}`
const code = (name: string) => (value: string) => /^\d{6}$/.test(value) ?
    undefined : `${validationHeader}.code.${name}`
const mobileNumber = (name: string) => (value: string) => {
    if (value === undefined || value === '') {
        return
    }

    return /^04\d{8}$/.test(value) ? undefined : `${validationHeader}.mobile.${name}`
}

export {
    composeValidators,
    required,
    email,
    password,
    minLength,
    noNumbers,
    postcode,
    mobileNumber,
    code
}
